import { ActionTree, ActionContext } from 'vuex';
import { State } from '@/stores/costcentres/state';
import { CostCentreApi } from '@/api/cost-centre-api';
import router from '@/router';
import { Forbidden } from '@/models/forbidden-error';
import { NotFound } from '@/models/not-found-error';

const api = new CostCentreApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public fetchAsync = async (context: ActionContext<State, any>) => {
        try {
            const result = await api.fetchAsync();
            if (result) {
                context.commit('setCostCentres', result.costCentres);
            }
        } catch (e) {
            if (e instanceof Forbidden) {
                router.push({ name: 'forbidden' });
            }
            if (e instanceof NotFound) {
                router.push({ name: 'not-found' });
            }
        }
    }
}
